import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { frameworkSteps } from '../../data/content';
export function Framework() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-164" data-mp="2mxput90e0fii">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-165" data-mp="28z9eqrgmxcnp">
        <div data-id="element-166" data-mp="2dxudemg8noa1">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-electric sm:text-sm" data-id="element-167" data-mp="2dxb6s1w1gmbb">
            Here’s what most clinicians need to understand
          </p>
          <h2 className="text-balance mt-4 font-display text-[32px] font-black leading-[1.05] tracking-tight text-white sm:text-5xl" data-id="element-168" data-mp="1z73mrhqduv8i">
            The Problem Isn’t Always Your Treatment Plan.
          </h2>
          <p className="mt-5 font-display text-xl font-bold leading-snug text-electric-light sm:text-2xl" data-id="element-169" data-mp="1v7cnsqqpd8sw">
            It’s the difference between the movement you program and the movement the appliance can actually deliver.
          </p>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-170" data-mp="1l83xc7v1qcba">
            <p data-id="element-171" data-mp="2yy1nyzmnf0bl">
              Orthodontic torque involves complex interactions between force systems, tooth anatomy, anchorage,
              appliance design, and biological response.
            </p>
            <p className="border-l-4 border-electric pl-4 font-semibold text-white" data-id="element-172" data-mp="37zsq5uhzcp0p">
              A beautiful digital simulation doesn’t automatically guarantee the same clinical outcome.
            </p>
            <p data-id="element-173" data-mp="2g9eiwh4h2ay0">
              That’s why understanding the mechanics behind the movement matters.{' '}
              <strong className="text-white" data-id="element-174" data-mp="2bajrwrwcpg2t">Orthodontic Torque Control Blueprint™</strong> is designed to help you
              evaluate these factors through a structured educational framework.
            </p>
          </div>
        </div>

        <div className="rounded-3xl border border-white/10 bg-navy p-5 sm:p-8" data-id="element-175" data-mp="2k83uc45y9if0">
          <p className="text-sm font-bold uppercase tracking-wide text-electric" data-id="element-176" data-mp="1wijbrmdpkn69">Introducing</p>
          <h3 className="mt-1 font-display text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-177" data-mp="1siikv29fajib">
            The 15-Minute Torque Planning Framework™
          </h3>
          <p className="mt-2 text-white/70" data-id="element-178" data-mp="g648kau2g6o">A five-stage clinical review process:</p>

          <ol className="relative mt-7 space-y-6" data-id="element-179" data-mp="57ehjrfaalp4">
            <span className="absolute bottom-4 left-[19px] top-4 w-0.5 bg-electric/30" aria-hidden="true" data-id="element-180" data-mp="5a0y2gk5kbjh" />
            {frameworkSteps.map((step, i) => <li key={step.name} className="relative flex gap-4" data-id="element-181" data-mp="38pg12xu45kv4" data-mpi={i}>
                <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-electric font-display text-lg font-black text-ink" data-id="element-182" data-mp="3dnrbb9oblxdv">
                  {i + 1}
                </span>
                <div className="pt-1" data-id="element-183" data-mp="3nmgmykpmillo">
                  <p className="font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-184" data-mp="3nni9blc3auip">{step.name}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/75" data-id="element-185" data-mp="xypp1mrhv0hi">{step.text}</p>
                </div>
              </li>)}
          </ol>

          <div className="mt-8 rounded-2xl bg-electric/10 p-4" data-id="element-186" data-mp="2ncfjq0niyacg">
            <p className="font-semibold text-white" data-id="element-187" data-mp="2iew8zaq1cfp9">
              The goal is simple: help you create a structured preliminary torque-control plan without overlooking
              important biomechanical considerations.
            </p>
            <p className="mt-2 text-xs text-white/55" data-id="element-188" data-mp="28o1ks0t8b616">
              Complex cases may require additional diagnostic work, specialist input, and longer planning.
            </p>
          </div>
        </div>
      </div>
      <SectionCTA label="Give me the 15-minute torque framework" data-id="element-189" data-mp="1zmuyfb3wf100" />
    </section>;
}